import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createVfm } from 'vue-final-modal';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import axios from 'axios';
import router from './routes.js';
import { displayInitialInfo, cw, hexToRgb } from './shared/utils.js';

// setup http clients
if ( window['_EZCL']?.data?.view?.colors ) {
  for (let key in _EZCL.data.view.colors) {
    let color = _EZCL.data.view.colors[key];
    document.documentElement.style.setProperty("--c-" + key, color);
    console.log(key)
    if (key == 'primary' && color) {
      let {r, g, b} = hexToRgb(color);
      let colorRgbString = `${r}, ${g}, ${b}`;
      document.documentElement.style.setProperty("--c-" + key + '-rgb', colorRgbString);
    }
  }
}
const restApiClient = axios.create({
  baseURL: window['_EZCL']?.restUrl,
  headers: {
    'X-WP-Nonce': window['_EZCL']?.nonce,
    'Content-Type': 'application/json',
  }
})

const adminAjaxClient = axios.create({
  baseURL: window['_EZCL']?.ajaxUrl,
  headers: {
    'X-WP-Nonce': window['_EZCL']?.nonce,
    "Content-Type": "application/x-www-form-urlencoded"
  }
})

// styles
import '@client/css/style.scss';
import 'vue-final-modal/style.css'

import App from './App.vue';

const app = createApp(App);

const storage = createPinia();
const vfm = createVfm();

storage.use(piniaPluginPersistedstate); // make storage persist state

app.use(storage); 
app.use(router);
app.use(vfm)

/* TODO:  */
app.provide('adminAjax', adminAjaxClient);
app.provide('restApi', restApiClient);
app.provide('rootData', window['_EZCL']?.data);
app.provide('storagePrefix', `_ezcl/${window.location.hostname}/${window['_EZCL']?.data.id}/`); // NOTE: not used in stores directly 

/* Mount */
const applicationRootContainer = document.getElementById('ezcl-root');
if (applicationRootContainer instanceof HTMLElement) {
  if (!window['_EZCL']) {
    console.warn('🟧 %cEZQR Ordering%c: no application settings found', ...cw('orange'))
  } else {
    app.mount( applicationRootContainer );
    console.log('🟩 %cEZQR Ordering%c: app mounted', ...cw('green'))
    displayInitialInfo();
  }
} else {
  console.error('🟥 %cEZQR Ordering%c: root container not founded', ...cw('red'))
}
